import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { managerV1BaseUrl } from '@/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CancelDialog({
  triggerComponent,
}: {
  triggerComponent: React.ReactNode;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const navigateBack = () => {
    window.location.replace(managerV1BaseUrl);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{triggerComponent}</DialogTrigger>
      <DialogContent>
        <div className="flex flex-col gap-4">
          <DialogTitle className="text-neutrals-900 text-lg font-semibold">
            {t('domain.mitarbeiter.create.dialogTitle')}
          </DialogTitle>
          <div className="flex flex-col gap-8">
            <DialogDescription className="text-neutrals-700 text-sm font-normal">
              {t('domain.mitarbeiter.create.dialogText')}
            </DialogDescription>
            <DialogFooter className="flex gap-4 ml-auto">
              <Button variant="outline" onClick={navigateBack}>
                {t('domain.mitarbeiter.create.submitDialog')}
              </Button>
              <Button variant="default" onClick={() => setOpen(false)}>
                {t('domain.mitarbeiter.create.cancelDialog')}
              </Button>
            </DialogFooter>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
